import React from 'react'

const Tab = ({tabs,setTabName,tabName}) => {
    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
      }
  return (
    <div>
      <div className="sm:hidden max-sm:p-[15px] max-sm:pb-0">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
        <select
          onChange={(e)=>{setTabName(e.target.value);}}
          id="tabs"
          name="tabs"
          className="block w-full rounded-md border-gray-300 max-sm:px-2.5 max-sm:py-0.5 py-2 pl-3 pr-10 text-base focus:border-gray-300 focus:outline-none focus:ring-white sm:text-sm"
          defaultValue={tabs.find((tab) => tab.current).name}
        >
          {tabs.map((tab) => (
            <option key={tab.name}>{tab.name}</option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block overflow-x-auto removeScroll">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex max-lg:space-x-2 space-x-8" aria-label="Tabs">
            {tabs.map((tab) => (
              <div
                key={tab.name}
                // href={tab.href}
                onClick={()=>{setTabName(tab.name)}}
                className={classNames(
                  tabName == tab.name 
                    ? 'border-[var(--brand-primary)] text-gray-900'
                    : 'border-transparent text-gray-600 hover:border-gray-300 hover:text-gray-700',
                  'whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium cursor-pointer'
                )}
                aria-current={tab.current ? 'page' : undefined}
              >
                {tab.name}
              </div>
            ))}
          </nav>
        </div>
      </div>
          </div>
  )
}

export default Tab